import React, { memo, useMemo } from 'react'
import {
  RelatedCampaignLink,
  RelatedCityLink,
  RelatedMissionLink,
  RelatedUserLink,
} from '../Links'

import { Td } from 'Components/Table/Td'
import { Tr } from 'Components/Table/Tr'
import { formatTimeInTz } from 'shared/libraries/utils/date'

export default memo(props => {
  const {
    dateTime,
    quantity,
    comments,
    tag,
    cityId,
    cityTimezone,
    relatedUserId,
    relatedUserName,
    relatedMissionId,
    relatedCityId,
    relatedCityName,
    relatedCampaign,
    classes,
  } = props

  const readableDateTimeString = useMemo(() =>
    formatTimeInTz(dateTime, cityTimezone, 'DD/MM/YYYY HH:mm'),
  )

  return (
    <Tr>
      <Td>{readableDateTimeString}</Td>
      <Td>{quantity}</Td>
      <Td>{tag}</Td>
      <Td>
        <RelatedCampaignLink
          relatedCampaign={relatedCampaign}
          comments={comments}
          classes={classes}
        />
      </Td>
      <Td>
        <RelatedUserLink
          relatedUserId={relatedUserId}
          relatedUserName={relatedUserName}
          cityId={cityId}
        />
      </Td>
      <Td>
        <RelatedMissionLink relatedMissionId={relatedMissionId} />
      </Td>
      <Td>
        <RelatedCityLink
          relatedCityId={relatedCityId}
          relatedCityName={relatedCityName}
        />
      </Td>
    </Tr>
  )
})
